import React from 'react'
import Layout from './_patternsLayout';
import content from 'locale/methods/en/patterns.yml';
import Helmet from 'react-helmet';

export default (props) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>
          SciChess | Patterns
        </title>
      </Helmet>
      <Layout content={content} {...props} />
    </React.Fragment>
  )
}

export const query = graphql`
  query patternsImageEn {
      img: file(absolutePath: { regex: "/eyetracking/" }) {
      childImageSharp {
        sizes(maxWidth: 1200, quality: 100) {
        ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/methods/patterns/index.en.js